export default "__VITE_ASSET__c3903b20__"